import { Reveal, Eyebrow } from "./Reveal";
import { Fingerprint, Scale, Link2 } from "lucide-react";

const STEPS = [
  { icon: Fingerprint, title: "KYC / AML Clearance", text: "Every counterparty passes institutional due diligence before a single term sheet is drafted." },
  { icon: Scale, title: "Independent Assay", text: "SGS and Alex Stewart-class verification on each lot — weight, fineness, and serial integrity." },
  { icon: Link2, title: "Chain of Custody", text: "Serialized documentation follows the metal from refinery to vault to settlement account." },
];

export const Verification = () => (
  <section id="verification" data-testid="verification-section" className="py-28 lg:py-36 bg-[#0A0A0B] grain relative">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
        <div className="order-2 lg:order-1">
          <Reveal>
            <Eyebrow>Verification & Compliance</Eyebrow>
            <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-medium tracking-wide text-white leading-snug">
              Trust is not a policy. <span className="gold-text">It is a procedure.</span>
            </h2>
            <p className="mt-6 text-base text-zinc-400 leading-relaxed">
              Counterparty risk is the only risk that matters in physical markets.
              Our compliance architecture treats every transaction as auditable
              from origin to settlement — because our counterparties do.
            </p>
          </Reveal>
          <div className="mt-12 space-y-8">
            {STEPS.map((s, i) => (
              <Reveal key={s.title} delay={i * 0.1}>
                <div className="flex gap-5" data-testid={`verification-step-${i}`}>
                  <span className="font-mono2 text-[#C9A227] text-sm pt-1">0{i + 1}</span>
                  <div>
                    <h3 className="font-display text-lg text-[#E8C85A] tracking-wide flex items-center gap-3">
                      <s.icon size={17} className="text-[#C9A227]" /> {s.title}
                    </h3>
                    <p className="mt-1.5 text-sm text-zinc-400 leading-relaxed">{s.text}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
          <div className="mt-10">
            <a href="/compliance" data-testid="verification-link-compliance" className="font-mono2 text-[11px] uppercase tracking-[0.25em] text-[#C9A227] hover:text-[#E8C85A] transition-colors">
              View the full compliance framework →
            </a>
          </div>
        </div>

        <Reveal className="order-1 lg:order-2">
          <div className="relative">
            <div className="absolute -inset-4 card-line pointer-events-none" />
            <img
              src="/assets/inspection.webp"
              alt="Inspector examining a fine gold bar and coin under magnification"
              className="w-full aspect-square object-cover"
              loading="lazy"
            />
            <div className="absolute top-5 right-5 bg-[#0A0A0B]/85 backdrop-blur px-5 py-3 card-line">
              <span className="font-mono2 text-[11px] tracking-[0.25em] text-[#C9A227] uppercase">999.9 Fine · Verified</span>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
